import React from 'react';

import {Helmet} from 'views/module';

import NewCaregiverScene from 'views/scenes/caregiver/new/NewCaregiver';

const CaregiverNew = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: New Caregiver</title>
      </Helmet>
      <NewCaregiverScene
      />
    </>
  );
};

export default CaregiverNew;
